import { useQuery } from 'react-query';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { AadeBookInvoiceType } from '../../../interfaces/myData.interface';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

export interface DocByMarkResponse extends GenericResponse {
  data?: {
    invoice?: InvoiceInterface;
    doc?: AadeBookInvoiceType;
    /** Only meaningful alongside `doc` - whether the current company is the doc's issuer. */
    isIssuer?: boolean;
  };
}

const getDocByMarkService = async (mark: string | undefined): Promise<DocByMarkResponse> => {
  const resp = await apiRQ.get<DocByMarkResponse>(`/invoices/mark/${mark}`);

  return resp?.data;
};

export const useDocByMark = (mark: string | undefined) => {
  return useQuery<DocByMarkResponse, Error>(['useDocByMark', mark], () => getDocByMarkService(mark), {
    enabled: !!mark,
    cacheTime: 2000,
    staleTime: 2000,
    refetchOnWindowFocus: false,
    // This response already carries the full invoice - seed `useSale`'s cache under its own key
    // so that rendering `SaleScreen`/`SaleWrapper` right after (see `ViewDocByMarkScreen`) finds
    // fresh data already there and doesn't re-fetch the same doc by id.
    onSuccess: (resp) => {
      if (resp?.data?.invoice?.id) {
        queryClient.setQueryData(['getSale', resp.data.invoice.id], resp.data.invoice);
      }
    },
  });
};
